import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faListCheck,
    faArrowRight,
    faPenToSquare,
    faHandPointLeft,
    faArrowDown,
    faHandPointUp,
} from '@fortawesome/free-solid-svg-icons';

const BeforeSelectPrompts = () => {
    return (
        <div className='bg-backgrounds-slate w-full min-h-[50vh] rounded-xl'>
            <div className='w-full h-full flex flex-col items-center justify-center py-10 px-3'>
                <div className='flex flex-col lg:flex-row items-center justify-center text-texts-secondary300'>
                    <div className='flex flex-col items-center justify-center m-6'>
                        <FontAwesomeIcon
                            icon={faListCheck}
                            className='w-20 h-20 lg:w-[5vw] lg:h-[5vw] drop-shadow text-icons-primary100'
                        />
                        <div className='text-base lg:text-sm p-1 font-semibold'>
                            Select Process
                        </div>
                    </div>

                    <FontAwesomeIcon
                        icon={faArrowDown}
                        className='w-10 h-10 my-3 drop-shadow text-icons-tertiary100 lg:hidden'
                    />
                    <FontAwesomeIcon
                        icon={faArrowRight}
                        className='w-[4vw] h-[4vw] m-[3vw] drop-shadow text-icons-tertiary100 hidden lg:block'
                    />

                    <div className='flex flex-col items-center justify-center m-6'>
                        <FontAwesomeIcon
                            icon={faPenToSquare}
                            className='w-20 h-20 lg:w-[5vw] lg:h-[5vw] drop-shadow text-icons-primary100'
                        />
                        <div className='text-base lg:text-sm p-1 font-semibold'>
                            Edit Prompt
                        </div>
                    </div>
                </div>

                <div className='flex items-center justify-center text-texts-secondary300 text-base md:text-xl pt-8 text-center'>
                    <FontAwesomeIcon
                        icon={faHandPointUp}
                        className='mr-3 text-icons-primary lg:hidden'
                    />
                    <FontAwesomeIcon
                        icon={faHandPointLeft}
                        className='mr-3 text-icons-primary hidden lg:block'
                    />
                    <div>
                        Select a process from the list under Prompts in the Prompt
                        Settings sidebar to continue
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BeforeSelectPrompts;
